import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { Device } from '@src/types/Device';

export default (options?: { enabled: boolean }) =>
  useApiQuery<
    Device[],
    { devices: { name: string; deviceId: string; type: string }[] }
  >({
    queryKey: [QueryKeys.unitControllers],
    apiPath: '/devices/search',
    method: 'POST',
    body: { filter: { type: 'unitController', deleted: false } },
    useV2API: true,
    enabled: options?.enabled ?? true,
    select: (data) => ({
      devices: (data as Device[]).map((d) => ({
        name: d.name,
        deviceId: d.deviceId,
        type: d.type,
      })),
    }),
  });
